// @ts-nocheck
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/LegalPage.css";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="legal-back" onClick={() => navigate("/home")}> 
          Back to Home
        </button>

        <h1>Page not found</h1>
        <p className="legal-updated">The page you are looking for does not exist.</p>

        <section className="legal-section">
          <p>Check the URL or use the navigation to continue.</p>
        </section>
      </div>
    </div>
  );
}
